export default angular.module('syInitiate', [])
    .directive('syPageLoad', ['UsaBillaService', 'WebChatService', '$rootScope', function (UsaBillaService, WebChatService, $rootScope) {
        return {
            restrict: 'E',
            link: function ($scope, $element, attrs) {
                window.currentEnvironment = attrs.currentEnvironment ? attrs.currentEnvironment.toLowerCase() : "";
                $rootScope.$broadcast('websiteLoaded');
                UsaBillaService.initiateUsaBilla();
                WebChatService.initiateWebChat();
            }
        };
    }])
    .service('UsaBillaService', ['$rootScope', '$rootElement', function ($rootScope, $rootElement) {
        this.initiateUsaBilla = function () {
            var currentApp = $rootElement.attr('ng-app');
            var voc_pageloadstart = Date.now();
            if (window.currentEnvironment == "production") {
                if (currentApp == "syXmasLights") {
           /*{literal}<![CDATA[*/window.lightningjs || function (c) { function g(b, d) { d && (d += (/\?/.test(d) ? "&" : "?") + "lv=1"); c[b] || function () { var i = window, h = document, j = b, g = h.location.protocol, l = "load", k = 0; (function () { function b() { a.P(l); a.w = 1; c[j]("_load") } c[j] = function () { function m() { m.id = e; return c[j].apply(m, arguments) } var b, e = ++k; b = this && this != i ? this.id || 0 : 0; (a.s = a.s || []).push([e, b, arguments]); m.then = function (b, c, h) { var d = a.fh[e] = a.fh[e] || [], j = a.eh[e] = a.eh[e] || [], f = a.ph[e] = a.ph[e] || []; b && d.push(b); c && j.push(c); h && f.push(h); return m }; return m }; var a = c[j]._ = {}; a.fh = {}; a.eh = {}; a.ph = {}; a.l = d ? d.replace(/^\/\//, (g == "https:" ? g : "http:") + "//") : d; a.p = { 0: +new Date }; a.P = function (b) { a.p[b] = new Date - a.p[0] }; a.w && b(); i.addEventListener ? i.addEventListener(l, b, !1) : i.attachEvent("on" + l, b); var q = function () { function b() { return ["<head></head><", c, ' onload="var d=', n, ";d.getElementsByTagName('head')[0].", d, "(d.", g, "('script')).", i, "='", a.l, "'\"></", c, ">"].join("") } var c = "body", e = h[c]; if (!e) return setTimeout(q, 100); a.P(1); var d = "appendChild", g = "createElement", i = "src", k = h[g]("div"), l = k[d](h[g]("div")), f = h[g]("iframe"), n = "document", p; k.style.display = "none"; e.insertBefore(k, e.firstChild).id = o + "-" + j; f.frameBorder = "0"; f.id = o + "-frame-" + j; /MSIE[ ]+6/.test(navigator.userAgent) && (f[i] = "javascript:false"); f.allowTransparency = "true"; l[d](f); try { f.contentWindow[n].open() } catch (s) { a.domain = h.domain, p = "javascript:var d=" + n + ".open();d.domain='" + h.domain + "';", f[i] = p + "void(0);" } try { var r = f.contentWindow[n]; r.write(b()); r.close() } catch (t) { f[i] = p + 'd.write("' + b().replace(/"/g, String.fromCharCode(92) + '"') + '");d.close();' } a.P(2) }; a.l && setTimeout(q, 0) })() }(); c[b].lv = "1"; return c[b] } var o = "lightningjs", k = window[o] = g(o); k.require = g; k.modules = c }({}); window.usabilla_live = lightningjs.require("usabilla_live", "//w.usabilla.com/d33a78489b4d.js");/*]]>{/literal}*/
                }
                else {
                    window.lightningjs || function (i) { function a(a, n) { var t, l, r, o, s, d; return n && (n += (/\?/.test(n) ? "&" : "?") + "lv=1"), i[a] || (t = window, l = document, r = a, o = l.location.protocol, s = "load", d = 0, function () { function a() { u.P(s), u.w = 1, i[r]("_load") } i[r] = function () { function a() { return a.id = n, i[r].apply(a, arguments) } var e, n = ++d; return e = this && this != t && this.id || 0, (u.s = u.s || []).push([n, e, arguments]), a.then = function (i, e, t) { var l = u.fh[n] = u.fh[n] || [], r = u.eh[n] = u.eh[n] || [], o = u.ph[n] = u.ph[n] || []; return i && l.push(i), e && r.push(e), t && o.push(t), a }, a }; var u = i[r]._ = {}; u.fh = {}, u.eh = {}, u.ph = {}, u.l = n ? n.replace(/^\/\//, ("https:" == o ? o : "http:") + "//") : n, u.p = { 0: +new Date }, u.P = function (i) { u.p[i] = new Date - u.p[0] }, u.w && a(), t.addEventListener ? t.addEventListener(s, a, !1) : t.attachEvent("on" + s, a); var c = function () { function i() { return ["<head></head><", a, ' onload="var d=', p, ";d.getElementsByTagName('head')[0].", o, "(d.", s, "('script')).", d, "='", u.l, "'\"></", a, ">"].join("") } var a = "body", n = l[a]; if (!n) return setTimeout(c, 100); u.P(1); var t, o = "appendChild", s = "createElement", d = "src", h = l[s]("div"), v = h[o](l[s]("div")), w = l[s]("iframe"), p = "document"; h.style.display = "none", n.insertBefore(h, n.firstChild).id = e + "-" + r, w.frameBorder = "0", w.id = e + "-frame-" + r, /MSIE[ ]+6/.test(navigator.userAgent) && (w[d] = "javascript:false"), w.allowTransparency = "true", v[o](w); try { w.contentWindow[p].open() } catch (i) { u.domain = l.domain, t = "javascript:var d=" + p + ".open();d.domain='" + l.domain + "';", w[d] = t + "void(0);" } try { var b = w.contentWindow[p]; b.write(i()), b.close() } catch (a) { w[d] = t + 'd.write("' + i().replace(/"/g, String.fromCharCode(92) + '"') + '");d.close();' } u.P(2) }; u.l && setTimeout(c, 0) }()), i[a].lv = "1", i[a] } var e = "lightningjs", n = window[e] = a(e); n.require = a, n.modules = i }({}); var ua = navigator.userAgent; ua.match(/Android/i) ? ua.match(/Mobile/i) ? window.usabilla_live = lightningjs.require("usabilla_live", "//w.usabilla.com/7ab213bab341.js") : window.usabilla_live = lightningjs.require("usabilla_live", "//w.usabilla.com/17544d5ca67f.js") : ua.match(/iPad|iProd|tablet|Kindle/i) ? window.usabilla_live = lightningjs.require("usabilla_live", "//w.usabilla.com/17544d5ca67f.js") : ua.match(/BlackBerry|BB10|iPhone|iPod|Opera Mini|IEMobile/i) ? window.usabilla_live = lightningjs.require("usabilla_live", "//w.usabilla.com/7ab213bab341.js") : window.usabilla_live = lightningjs.require("usabilla_live", "//w.usabilla.com/cca507b874fa.js");
                }
            }
            else {
                //< !--Usabilla Combicode for Synergy - Staging(general)-- >
                //< !--Begin Usabilla for Websites embed code-- >
                /*{literal}<![CDATA[*/
                window.lightningjs || function (c) {
                    function g(b, d) {
                        d && (d += (/\?/.test(d) ? "&" : "?") + "lv=1");
                        c[b] || function () {
                            var i = window, h = document, j = b, g = h.location.protocol, l = "load", k = 0;
                            (function () {
                                function b() {
                                    a.P(l);
                                    a.w = 1;
                                    c[j]("_load")
                                }

                                c[j] = function () {
                                    function m() {
                                        m.id = e;
                                        return c[j].apply(m, arguments)
                                    }

                                    var b, e = ++k;
                                    b = this && this != i ? this.id || 0 : 0;
                                    (a.s = a.s || []).push([e, b, arguments]);
                                    m.then = function (b, c, h) {
                                        var d = a.fh[e] = a.fh[e] || [], j = a.eh[e] = a.eh[e] || [], f = a.ph[e] = a.ph[e] || [];
                                        b && d.push(b);
                                        c && j.push(c);
                                        h && f.push(h);
                                        return m
                                    };
                                    return m
                                };
                                var a = c[j]._ = {};
                                a.fh = {};
                                a.eh = {};
                                a.ph = {};
                                a.l = d ? d.replace(/^\/\//, (g == "https:" ? g : "http:") + "//") : d;
                                a.p = { 0: +new Date };
                                a.P = function (b) {
                                    a.p[b] = new Date - a.p[0]
                                };
                                a.w && b();
                                i.addEventListener ? i.addEventListener(l, b, !1) : i.attachEvent("on" + l, b);
                                var q = function () {
                                    function b() {
                                        return ["<head></head><", c, ' onload="var d=', n, ";d.getElementsByTagName('head')[0].", d, "(d.", g, "('script')).", i, "='", a.l, "'\"></", c, ">"].join("")
                                    }

                                    var c = "body", e = h[c];
                                    if (!e) return setTimeout(q, 100);
                                    a.P(1);
                                    var d = "appendChild", g = "createElement", i = "src", k = h[g]("div"), l = k[d](h[g]("div")),
                                        f = h[g]("iframe"), n = "document", p;
                                    k.style.display = "none";
                                    e.insertBefore(k, e.firstChild).id = o + "-" + j;
                                    f.frameBorder = "0";
                                    f.id = o + "-frame-" + j;
                                    /MSIE[ ]+6/.test(navigator.userAgent) && (f[i] = "javascript:false");
                                    f.allowTransparency = "true";
                                    l[d](f);
                                    try {
                                        f.contentWindow[n].open()
                                    } catch (s) {
                                        a.domain = h.domain, p = "javascript:var d=" + n + ".open();d.domain='" + h.domain + "';", f[i] = p + "void(0);"
                                    }
                                    try {
                                        var r = f.contentWindow[n];
                                        r.write(b());
                                        r.close()
                                    } catch (t) {
                                        f[i] = p + 'd.write("' + b().replace(/"/g, String.fromCharCode(92) + '"') + '");d.close();'
                                    }
                                    a.P(2)
                                };
                                a.l && setTimeout(q, 0)
                            })()
                        }();
                        c[b].lv = "1";
                        return c[b]
                    }

                    var o = "lightningjs", k = window[o] = g(o);
                    k.require = g;
                    k.modules = c
                }({});
                if (!navigator.userAgent.match(/Android|BlackBerry|BB10|iPhone|iPad|iPod|Opera Mini|IEMobile/i)) {
                    window.usabilla_live = lightningjs.require("usabilla_live", "//w.usabilla.com/d378e4f4a6f4.js");
                } else {
                    window.usabilla_live = lightningjs.require("usabilla_live", "//w.usabilla.com/4e88c7d837e7.js");
                }/*]]>{/literal}*/
            }

            function dw_getwindowdims() {
                var doc = document, w = window;
                var docEl = (doc.compatMode && doc.compatMode === 'CSS1Compat') ?
                    doc.documentElement : doc.body;

                var width = docEl.clientWidth;
                var height = docEl.clientHeight;

                // mobile zoomed in?
                if (w.innerWidth && width > w.innerWidth) {
                    width = w.innerWidth;
                    height = w.innerHeight;
                }
                return { width: width, height: height };
            }
            var voc_viewpointarray = dw_getwindowdims();
            function isjson(str) {
                try {
                    return (JSON.parse(str) && !!str);
                } catch (e) {
                    return false;
                }
            }
            function getclientip(url) {
                try {
                    var ipavoc = "";
                    var xhttpvoc = new XMLHttpRequest();
                    xhttpvoc.onreadystatechange = function () {
                        if (this.readyState == 4 && this.status == 200) {
                            if (isjson(this.response)) {
                                ipavoc = JSON.parse(this.response).ip.toString();
                            }
                            else {
                                ipavoc = this.response;
                            }
                        }
                        else {
                            ipavoc = "IP service not working";
                        }

                    }
                    xhttpvoc.open("GET", url, false);
                    xhttpvoc.send();
                    return ipavoc;
                } catch (e) {
                    return "IP service not working";
                }
            }
            var voc_ipaddress = getclientip('https://jsonip.com/');
            var voc_pageloadtime = Date.now() - voc_pageloadstart;
            window.usabilla_live('data', {
                'custom': {
                    'userip': (voc_ipaddress == undefined || voc_ipaddress == "IP service not working") ? getclientip('https://api.ipify.org') : voc_ipaddress,
                    'viewpoint': voc_viewpointarray.width + 'x' + voc_viewpointarray.height,
                    'pageloadtime': voc_pageloadtime + 's'
                }
            });


            window.usabilla_live('setEventCallback', function (category, action, label, value, userData) {
                function flat(source, target) {
                    Object.keys(source).forEach(function (k) {
                        if (source[k] !== null && typeof source[k] === 'object') {
                            flat(source[k], target);
                            return;
                        }
                        target[k] = source[k];
                    });
                }
                var userDataFlat = {};
                flat(userData, userDataFlat);
                var voc_cookiesexpirydate = new Date();
                voc_cookiesexpirydate.setTime(voc_cookiesexpirydate.getTime() + (1 * 24 * 60 * 60 * 1000));
                var voc_cookiesexpires = ";expires=" + voc_cookiesexpirydate;
                if (action === "Feedback:Open") {
                    $rootScope.$broadcast('feedbackOpen');
                    document.cookie = "Feedback:open=UsabillaFeedback_open" + voc_cookiesexpires + ";path=/";
                }
                if (action === "Feedback:Success") {                    
                    $rootScope.$broadcast('feedbackSuccess', userDataFlat);
                    document.cookie = "Feedback:complete=UsabillaFeedback_complete" + voc_cookiesexpires + ";path=/";
                }
                if (action === 'Campaign:Open') {
                    $rootScope.$broadcast('campaignOpen');
                    document.cookie = "Campaign:open=UsabillaCampaign_open" + voc_cookiesexpires + ";path=/";
                }
                if (action === 'Campaign:Success') {                   
                    $rootScope.$broadcast('campaignSuccess', userDataFlat);
                    document.cookie = "Campaign:complete=UsabillaCampaign_complete" + voc_cookiesexpires + ";path=/";
                }
                if (action === 'Campaign:Close') {
                    $rootScope.$broadcast('campaignClose');
                    document.cookie = "Campaign:close=UsabillaCampaign_close" + voc_cookiesexpires + ";path=/";
                }

                // This wouldn't work in IE 8 and IE 9, cause we use `XDomainRequest` when supported
                function sendReplacement(vData) {
                    var data = JSON.parse(vData);
                    data.url = data.url.replace(new RegExp("##"), "#");
                    var pagevoctiming = data.timing.connectEnd - data.timing.loadEventEnd;
                    data.custom.pageloadtime = pagevoctiming > 0 ? pagevoctiming / 1000 + 's' : pagevoctiming < 0 ? (pagevoctiming * -1) / 1000 + 's' : pagevoctiming + 's';
                    data.custom.viewpoint = data.viewport.width + 'x' + data.viewport.height;
                    vData = JSON.stringify(data);
                    realSend.apply(this, arguments);
                }

                var realSend = XMLHttpRequest.prototype.send;
                ub_window = document.getElementById('lightningjs-frame-usabilla_live_feedback').contentWindow;
                ub_window.XMLHttpRequest.prototype.send = sendReplacement;
                if (window.XDomainRequest) {
                    realSend = XDomainRequest.prototype.send;
                    ub_window.XDomainRequest.prototype.send = sendReplacement;
                }
            });
        }
    }])
    .service('WebChatService', ['$rootScope', '$rootElement', function ($rootScope, $rootElement) {
        this.initiateWebChat = function () {
            var currentApp = $rootElement.attr('ng-app');
            if (currentApp == "app") {
                var iN = (window.currentEnvironment == "production") ? "1000607" : "1000606";
                (function (u, t, d) {
                    var i = d.createElement(t); i.type = 'text/javascript'; i.async = true; i.src = '//' + u;
                    var s = d.getElementsByTagName(t)[0]; s.parentNode.insertBefore(i, s);
                })('stellar-tracker.inside-graph.com/gtm/IN-' + iN + '/include.js', 'script', document);

                window._inside = window._inside || [];
                window._inside.push({
                    "action": "bind",
                    "name": "chatavailable",
                    "callback": function (available) {
                        $rootScope.$broadcast('chatAvailable', available);
                    }
                });
            }
        }
    }]);